import { Wrapper } from "./Wrapper";

const Container = (props) => <Wrapper>{props.children}</Wrapper>;
export default Container;
